﻿import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Bell, BellDot, Menu } from "lucide-react";

import classes from "@/components/desktop/header/header.module.scss";

import HeaderFilter from "@/components/desktop/header/filter";
import HeaderSearch from "@/components/desktop/header/search";

import { ReactComponent as LogoSvg } from "@/assets/images/mobile/logo-agro.svg";

import { agricolaName } from "@/services/Utils";

import { UPDATE_FETCHING_GLOBAL, UPDATE_USER, CHANGE_SEASON } from "@/redux/types/auth.types";
import useSyncedFilter from "@/hooks/general/useSyncedFilter";

import { customStyles, customStylesCustomer, routeOptions, routeSearch } from "./header.constants";
import HeaderMenu from "./HeaderMenu";
import apiService from "@/services/api.service";

const Header = ({ changeOpenSidebar }) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { filter, updateFilter } = useSyncedFilter();

	const { user, notifications, customers } = useSelector((state) => state.auth);
	const { openSidebar } = useSelector((state) => state.main);

	const [openFilter, setOpenFilter] = useState(false);
	const [parameter, setParameter] = useState("");
	const [search, setSearch] = useState(filter && filter.search);

	const [options, setOptions] = useState(routeOptions[location.pathname] || []);

	useEffect(() => {
		setOptions(routeOptions[location.pathname] || []);
		setParameter(filter && filter.parameter);
	}, [location.pathname, filter]);

	const handleChangeCustomer = (selected) => {
		dispatch({
			type: UPDATE_FETCHING_GLOBAL,
			payload: {
				isFetchingGlobal: true,
			},
		});

		apiService.post("/admin/change-customer", { customer_id: selected.value }).then((response) => {
			if (response) {
				let currentUser = { ...user };
				currentUser.customer = response.customer;
				currentUser.estates = response.estates;
				currentUser.estates_parents = response.estates_parents;

				localStorage.setItem("token", JSON.stringify(response.token));

				dispatch({
					type: CHANGE_SEASON,
					payload: {
						season: response.season,
					},
				});

				dispatch({
					type: UPDATE_USER,
					payload: {
						user: currentUser,
					},
				});

				let currentFilter = { ...filter };
				currentFilter.estate_id = response.estates.map((estate) => estate.value).join(",");
				currentFilter.estate_parent_id = response.estates_parents.map((estate) => estate.value).join(",");

				updateFilter({
					estate_id: currentFilter.estate_id,
					estate_parent_id: currentFilter.estate_parent_id,
					season_id: response.season ? response.season.value : null,
				});
			}
			dispatch({
				type: UPDATE_FETCHING_GLOBAL,
				payload: {
					isFetchingGlobal: false,
				},
			});
		});
	};

	const urlEnv = process.env.REACT_APP_API_URL;

	let showCustomer = customers && customers.length > 1;

	const routesWithSelector = Object.keys(routeOptions);

	return (
		<div className={`no_print ${classes.headerGlobal}`}>
			<div className={classes.header} style={{ borderBottom: urlEnv === "https://staging-api.agroinventario.cl" ? "15px solid #dc3545" : "" }}>
				<div className={classes.colLogo}>
					<Menu
						className={openSidebar ? classes.logo_sidebar_green : classes.logo_sidebar}
						onClick={() => changeOpenSidebar(!openSidebar)}
						size={24}
						strokeWidth={2}
						style={{ cursor: "pointer" }}
					/>

					<LogoSvg style={{ cursor: "pointer", width: "9em" }} className={classes.logo} onClick={() => navigate("/")} />
				</div>

				<div className={classes.search} style={{ flexBasis: showCustomer ? "50%" : "66.666%" }}>
					{routeSearch.includes(location.pathname) && (
						<HeaderSearch
							parameter={parameter}
							setParameter={setParameter}
							search={search}
							setSearch={setSearch}
							options={routesWithSelector.includes(location.pathname) ? options : []}
							customStyles={customStyles}
						/>
					)}
				</div>

				{showCustomer && customers && customers.length > 1 && (
					<div className={classes.select_customer}>
						<Select
							options={customers.map((customer) => ({ value: customer.value, label: agricolaName(customer.label) }))}
							styles={customStylesCustomer}
							placeholder="Cambiar de cliente"
							value={customers.find((customer) => user?.customer && Number(customer.value) === Number(user.customer.id))}
							onChange={(selectedOption) => handleChangeCustomer(selectedOption)}
						/>
					</div>
				)}

				<div className={classes.center_logo}>
					<LogoSvg style={{ cursor: "pointer", width: "9em" }} onClick={() => navigate("/")} />
				</div>

				<div className={classes.options}>
					<div className={classes.item}>
						<HeaderFilter openFilter={openFilter} setOpenFilter={setOpenFilter} />
					</div>

					<div className={classes.item}>
						{notifications && notifications.length === 0 ? (
							<Bell className={classes.iconNotification} onClick={() => navigate("/notificaciones")} size={24} strokeWidth={2} />
						) : (
							<BellDot className={classes.iconNotification} onClick={() => navigate("/notificaciones")} size={24} strokeWidth={2} />
						)}
					</div>

					<HeaderMenu />
				</div>
			</div>
		</div>
	);
};

export default Header;
